
    <app-kontable
      title="{{ 'promotion.template' | translate }}"
      [columns]="['id', 'code', 'description']"
      [titles]="['#', 'promotion.code', 'promotion.description']"
      [source]="templates"
      [showInfoButton]="true"
      [showRecoverButton]="false"
      [showDetailsButton]="false"
      [showAddButton]="true"
      [showGlobalFilter]="false"
      (onAdd)="showAdd()"
      (onEdit)="showEdit($event)"
      (onRemove)="delete($event)"
      *ngIf="!show">
    </app-kontable>
    <kv-promo-template-detail
      *ngIf="show"
      [titlePage]="titlePage"
      [template]="addEditTemplate"
      (hide)="toggleShow()"
      (saveTemplate)="saveTemplate($event)">
    </kv-promo-template-detail>
  


// WEBPACK FOOTER //
// ./src/app/views/promotion/template/template.component.ts.TemplateComponent.html